import React, { useState } from "react";
export const screenshots = [
  require("./images/Screenshot_2025-01-27-18-54-30-247.jpg"),
  require("./images/Screenshot_2025-01-27-18-45-54-775.jpg"),
  require("./images/Screenshot_2025-01-27-18-46-59-183.jpg"),
  require("./images/Screenshot_2025-01-27-18-47-32-985.jpg"),
  require("./images/Screenshot_2025-01-27-18-48-14-696.jpg"),
  require("./images/Screenshot_2025-01-27-18-50-47-347.jpg"),
  require("./images/Screenshot_2025-01-27-18-52-23-064.jpg"),
  require("./images/Screenshot_2025-01-27-18-53-37-680.jpg"),
  require("./images/Screenshot_2025-01-27-18-44-58-262.jpg"),
];
export default function ScreenshotShowcase({ c }) {
  const [selected, setSelected] = useState(0);
  return (
    <section
      className="section showcase-section"
      id="screenshots"
      aria-labelledby="showcase-title"
    >
      <div className="container">
        <div className="section-heading">
          <div>
            <p className="eyebrow">{c.screenshots}</p>
            <h2 id="showcase-title">{c.showcaseTitle}</h2>
          </div>
          <p>{c.showcaseText}</p>
        </div>
        <div className="showcase-layout">
          <div
            className="screenshot-options"
            role="group"
            aria-label={c.screenshots}
          >
            {c.imageNames.map((name, index) => (
              <button
                key={name}
                type="button"
                aria-pressed={selected === index}
                aria-controls="selected-screenshot"
                onClick={() => setSelected(index)}
              >
                <span className="option-index">
                  {String(index + 1).padStart(2, "0")}
                </span>
                {name}
                <span className="option-arrow" aria-hidden="true">
                  ↗
                </span>
              </button>
            ))}
          </div>
          <figure id="selected-screenshot">
            <a
              href={screenshots[selected]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${c.fullSize}: ${c.imageNames[selected]}`}
            >
              <img
                src={screenshots[selected]}
                alt={c.imageLabels[selected]}
                width="1920"
                height="1200"
                loading="lazy"
                decoding="async"
              />
            </a>
            <figcaption>
              <span aria-live="polite">{c.imageNames[selected]}</span>
              <a
                href={screenshots[selected]}
                target="_blank"
                rel="noopener noreferrer"
              >
                {c.fullSize} ↗
              </a>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
